import React from "react";
import { connect } from "react-redux";

import { PromoEvent } from "../molecules/PromoCarousel/PromoCarousel";
import { Game } from "../models/Game";
import { User } from "../models/User";
import { HomePageSorting } from "../models/HomePageSorting";
import { HomeTemplate } from "../templates/Home/Home";
import { ErrorBoundary } from "../atoms/ErrorBoundary";

type HomeProps = {
  games: Game[];
  user: User;
  homePageSorting: HomePageSorting[];
  promo: PromoEvent[];
};

interface RootState {
  user: User;
  games: Game[];
  homePageSorting: HomePageSorting[];
  promo: PromoEvent[];
}

class Page extends React.PureComponent<HomeProps> {
  render() {
    const { games, user, homePageSorting, promo } = this.props;

    return (
      <ErrorBoundary>
        <HomeTemplate
          games={games}
          user={user}
          homePageSorting={homePageSorting}
          promo={promo}
        />
      </ErrorBoundary>
    );
  }
}

export const Home = connect((state: RootState) => ({
  games: state.games,
  user: state.user,
  homePageSorting: state.homePageSorting,
  promo: state.promo,
}))(Page);
